import { CheckCircle } from "@mui/icons-material"
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle"
import { Chip } from "@mui/material"

export default function ChipStatus({ active }) {
	return (
		<Chip
			icon={active ? <CheckCircle /> : <RemoveCircleIcon />}
			label={active ? "Activo" : "Desactivado"}
			color={active ? "success" : "error"}
			size="small"
		/>
	)
}
